import React from 'react';

import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface IHeroLinkProps {
  to: string;
  fullWidth?: boolean;
}

const UnStyledLink = styled(Link)<IHeroLinkProps>`
  width: ${p => (p.fullWidth ? '100%' : 'auto')};
  text-decoration: none;
`;

const UnStyledA = styled.a<{ fullWidth: boolean }>`
  width: ${p => (p.fullWidth ? '100%' : 'auto')};
  text-decoration: none;
`;

const HeroLink: React.FC<IHeroLinkProps> = ({ to, fullWidth = false, children, ...rest }) => {
  if (to.startsWith('/')) {
    return (
      <UnStyledLink fullWidth={fullWidth} to={to} {...rest}>
        {children}
      </UnStyledLink>
    );
  }
  return (
    <UnStyledA fullWidth={fullWidth} href={to} {...rest}>
      {children}
    </UnStyledA>
  );
};

export default HeroLink;
